import React from 'react';
import useLocalStorage from 'hooks/useLocalStorage';
import useScoreCardFilter from 'hooks/ScoreCard/useScoreCardFilter';
import useAnalyticsFilter from 'hooks/Analytics/useAnalyticsFilter';
import useEvaluationFilter from 'hooks/Evaluation/useEvaluationFilter';
import useInspectFilter from 'hooks/Inspect/useInspectFilter';

function FirstLoad() {
  const { filter: evaluationFilter, getEvaluationConfigDataAction } = useEvaluationFilter();
  const { filter: scoreCardFilter, getScoreCardConfigDataAction } = useScoreCardFilter();
  const { getAnalyticsConfigDataAction, filter: analyticsFilter } = useAnalyticsFilter();
  const { getInspectConfigDataAction, filter: inspectFilter } = useInspectFilter();

  const [config, setConfig] = useLocalStorage('qp-inital-load', false);
  React.useLayoutEffect(() => {
    if (!config) {
      if (!scoreCardFilter) getScoreCardConfigDataAction();
      if (!analyticsFilter) getAnalyticsConfigDataAction();
      if (!evaluationFilter) getEvaluationConfigDataAction();
      if (!inspectFilter) getInspectConfigDataAction();

      setConfig(true);
    }
  }, [scoreCardFilter, analyticsFilter, evaluationFilter, inspectFilter]);
  return <React.Fragment></React.Fragment>;
}

export default FirstLoad;
